import AdjudicationsListComponent from "src/components/Adjudications/AdjudicationsList"


const ActiveAdjudications = () => {
  return (
    <AdjudicationsListComponent status='active' label='Active' />
  )
}

export default ActiveAdjudications